(function ($) {

    const expandedCssClass = 'expanded';

    function toggleAccordionItem($accordionItem, options) {

        if (!$accordionItem) return;
        if (!$accordionItem.length) return;

        const toOpen = !$accordionItem.hasClass( expandedCssClass );

        if (!options.allowMultiple) {
            $accordionItem.siblings().each( function () {
                toggleAccordionItemEl($(this), false, options);
            });
        }

        toggleAccordionItemEl($accordionItem, toOpen, options);
    }



    function toggleAccordionItemEl($accordionItem, toOpen, options) {
        if (!$accordionItem) return;
        if (!$accordionItem.length) return;

        $accordionItem
            .find('.brand-accordion-title-cta')
            .attr('aria-expanded', toOpen ? 'true' : 'false');

        const $contentEl = $accordionItem.find('.brand-accordion-text');
        if (toOpen) {
            $accordionItem.addClass(expandedCssClass);
            $contentEl.show(options.animationSpeed);
        }
        else {
            $accordionItem.removeClass(expandedCssClass);
            $contentEl.hide(options.animationSpeed);
        }
    }



    $(document).on('ready', function () {

        $('.brand-accordion').each( function () {

            const $this = $(this);

            const $items = $this.find('.brand-accordion-item');

            const currentAccordionOptions = {
                allowMultiple: parseInt($this.data('allow-multiple')) === 1,
                expandInitially: parseInt($this.data('expand-initially')) === 1,
                initialItemIndex: parseInt($this.data('initial-item-index')),
                animationSpeed: parseInt($this.data('animation-speed')) || 200,
            }

            $this.find('.brand-accordion-title-cta').on('click', function (e) {
                 e.preventDefault();
            });

            $items.on('click', function (e) {
                // making sure that click was triggered by clicking on .brand-accordion-title (or one of its children elements)
                if ($(e.target).closest('.brand-accordion-title').length > 0) {
                    toggleAccordionItem($(this), currentAccordionOptions);
                }
            });


            if (currentAccordionOptions.expandInitially) {
                const itemToExpand = currentAccordionOptions.initialItemIndex || 0;

                if ((itemToExpand + 1) <= $items.length) {
                    toggleAccordionItem(
                        $items.eq(currentAccordionOptions.initialItemIndex || 0),
                        currentAccordionOptions
                    );
                }
                else {
                    console.warn(`Index for item to expand initially (${itemToExpand}) is out of range for accordion with id = ${$this.attr('id')}`);
                }
            }

        });

    });


})(jQuery);